import { jsx } from "react/jsx-runtime";
import { AdBuilderFlyout } from "./AdBuilder/index.js";
import { Banner } from "./Banner/index.js";
import { FlyoutLinkList } from "./FlyoutLinkList/index.js";
import { Markdown } from "./Markdown/index.js";
import { SegmentBasedEntryFlyout } from "./SegmentBasedEntryFlyout/index.js";
const SUBCOMPONENT_MAP = {
  ad_builder: AdBuilderFlyout,
  segment_based_entry_block: SegmentBasedEntryFlyout,
  banner: Banner,
  link_list: FlyoutLinkList,
  markdown: Markdown
};
function generateContent(composition, locale, isSplitContent) {
  if (composition === void 0) return null;
  const compNames = getCompKeys(composition);
  const compEntries = getCompValues(composition);
  const content = compNames.map((componentType, index) => {
    if (componentType === void 0 || componentType === null) return null;
    const Component = SUBCOMPONENT_MAP[componentType];
    const entry = compEntries[index];
    const style = isSplitContent && componentType === "ad_builder" ? { flex: 0 } : {};
    return /* @__PURE__ */ jsx(Component, { entry, locale, sx: style }, index);
  });
  return content;
}
function createComposition(composition) {
  const compNames = getCompKeys(composition);
  const compEntries = getCompValues(composition);
  return { compEntries, compNames };
}
function getCompKeys(composition) {
  return composition.map((entry) => Object.keys(entry)[0]);
}
function getCompValues(composition) {
  return composition.map((entry) => Object.values(entry)[0]);
}
export {
  createComposition,
  generateContent,
  getCompKeys,
  getCompValues
};
